import { MenuItem } from './menu.model';

/**
 * Flat, single-level sidebar nav for the AerTicket UAE admin section.
 * Icons are Font Awesome 5.13 (bundled via assets/scss/custom/plugins/icons).
 * Only `Country` and `Country Nationality Mapping` are built; the rest resolve
 * to the placeholder page in CmsModule.
 */
export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Product Management',
        isTitle: true
    },
    {
        id: 2,
        label: 'Country',
        icon: 'fa-globe',
        link: '/products/country'
    },
    {
        id: 3,
        label: 'Category & Subcategory',
        icon: 'fa-sitemap',
        link: '/cms/country-category-subcategory'
    },
    {
        id: 4,
        label: 'Country Nationality Mapping',
        icon: 'fa-network-wired',
        link: '/cms/country-nationality-mapping'
    },
    {
        id: 5,
        label: 'Trending Destinations',
        icon: 'fa-fire',
        link: '/cms/trending-destinations'
    },
    {
        id: 6,
        label: 'Visa Rule & Tax Engine',
        icon: 'fa-balance-scale',
        link: '/cms/country-visa-tax-agegroup-rule'
    },
    {
        id: 7,
        label: 'Template Master',
        icon: 'fa-layer-group',
        link: '/cms/country-faq-doc-template'
    },
    {
        id: 8,
        label: 'Document & FAQ Mapping',
        icon: 'fa-users',
        link: '/cms/country-faq-doc'
    },
    {
        id: 9,
        label: 'Visa Booking Workflow',
        icon: 'fa-project-diagram',
        link: '/cms/visa-booking-workflow'
    },
    {
        id: 10,
        label: 'Visa Application',
        icon: 'fa-box',
        link: '/cms/visa-bookings'
    },
    {
        id: 11,
        label: 'Addon Product Manager',
        icon: 'fa-puzzle-piece',
        link: '/cms/country-addon'
    },
    {
        id: 12,
        label: 'Notification & Alert',
        icon: 'fa-bell',
        link: '/cms/country-notification-alert'
    },
    {
        id: 13,
        label: 'Role & Access Manager',
        icon: 'fa-shield-alt',
        link: '/cms/access-management'
    },
    {
        id: 14,
        label: 'Communication Template',
        icon: 'fa-comments',
        link: '/cms/config-integration'
    },
    {
        id: 15,
        label: 'Country Questionare',
        icon: 'fa-clipboard-list',
        link: '/cms/country-questionare'
    },
    // {
    //     id: 16,
    //     label: 'Visa Report & Analytics',
    //     icon: 'fa-chart-pie',
    //     link: '/cms/report-analytics'
    // }
];
